// assets
import {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconMailbox,
    IconNotebook,
    IconLicense,
    IconArchive,
    IconFileX
} from '@tabler/icons';

// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconMailbox,
    IconNotebook,
    IconLicense,
    IconArchive,
    IconFileX
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const proposal = {
    id: 'proposal',
    title: 'menu.proposal.thisTitle',
    type: 'group',
    children: [
        {
            id: 'proposal-inbox',
            title: 'menu.proposal.proposalInbox',
            type: 'item',
            url: '/proposal/proposal-persetujuan/list',
            icon: icons.IconMailbox,
            breadcrumbs: false,
            roles: ['MARKETING']
        },
        {
            id: 'proposal-list',
            title: 'menu.proposal.daftarProposal',
            type: 'item',
            url: '/proposal/proposal/list',
            icon: icons.IconNotebook,
            breadcrumbs: false
        },
        {
            id: 'proposal-archive',
            title: 'menu.proposal.arsipProposal',
            type: 'item',
            url: '/proposal/proposal-archive/list',
            icon: icons.IconArchive,
            breadcrumbs: false
        },
        {
            id: 'proposal-log',
            title: 'menu.proposal.riwayatPersetujuan',
            type: 'item',
            url: '/proposal/proposal-log/list',
            icon: icons.IconLicense,
            breadcrumbs: false,
            roles: ['MARKETING']
        },
        {
            id: 'proposal-pembatalan',
            title: 'menu.proposal.proposalPembatalan',
            type: 'item',
            url: '/proposal/proposal-pembatalan/list',
            icon: icons.IconFileX,
            breadcrumbs: false,
            roles: ['FINANCE']
        }
    ]
};

export default proposal;
